import { KarrotLocalCountryCode } from "@karrotmarket-com/core";
import { default as GlobalGnb } from "./global/GlobalNavigationBar";
import { SearchBar as GlobalSearchBar } from "./global/SearchBar";
import { default as KRGnb } from "./kr/GlobalNavigationBar";
import { default as NAGnb } from "./north-america/GlobalNavigationBar";
import { SearchBar as NASearchBar } from "./north-america/SearchBar";

export const GlobalNavigationBarComponentsMap = {
  [KarrotLocalCountryCode.KR]: KRGnb,
  [KarrotLocalCountryCode.CA]: NAGnb,
  [KarrotLocalCountryCode.US]: NAGnb,
  [KarrotLocalCountryCode.JP]: GlobalGnb,
  [KarrotLocalCountryCode.UK]: GlobalGnb,
};

export const SearchBarComponentsMap = {
  [KarrotLocalCountryCode.KR]: GlobalSearchBar,
  [KarrotLocalCountryCode.CA]: NASearchBar,
  [KarrotLocalCountryCode.US]: NASearchBar,
  [KarrotLocalCountryCode.JP]: GlobalSearchBar,
  [KarrotLocalCountryCode.UK]: GlobalSearchBar,
};
